import * as theme from "../theme";

import React from "react";
import styled from "styled-components";
import Button from "../components/CustomButton";
import ErrorMessage from "../components/ErrorMessage";
import HeaderText from "../components/HeaderText";
import CustomInput from "../components/inputs/CustomInput";
import InputContainer from "../components/inputs/InputContainer";
import Context from "../contexts/data";

export default function ManualAddress() {
  const { address, errorMessage, handleUpdateFormValue, navigate } =
    React.useContext(Context);

  const handleNextStep = () => {
    if (!address) {
      handleUpdateFormValue("errorMessage", "Please enter a valid address.");
      return;
    }

    navigate("user-name", "Manual Address");
  };

  function handleUpdate(event) {
    handleUpdateFormValue("address", event.target.value);
  }

  return (
    <Wrapper>
      <HeaderText
        bigger_text={
          window.innerWidth > 500
            ? "What is your home address?"
            : "Your home address?"
        }
        smaller_text={
          window.innerWidth > 500 &&
          "Confirming your address will only be used to match you with relevant loan offers."
        }
      />
      <InputContainer>
        <CustomInput
          name={"manualAddressStreet"}
          onChange={handleUpdate}
          placeholder="Enter your street address"
          value={address}
          errorMessage={errorMessage}
          fieldClass="genericInput"
          labelName={"Street Address"}
        />
      </InputContainer>
      <ErrorMessage />
      <Button onClick={handleNextStep} />
    </Wrapper>
  );
}

const Wrapper = styled(theme.column_align)``;
